import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect, withRouter } from "react-router-dom";
import { PATHS } from "../../constant";
import {
  userLoginRequest,
  userSecurityKey,
  keycloakUserLogin
} from "../../actions/login.action";
import {
  getLocalstorage,
  setLocalstorage,
  removeItemFromLocalStorage
} from "../../helper";
import cookieService from "../../services/cookieService";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { keycloak } from "../../globalConfig";

const keycloakConfig = {
  checkLoginIframe: false,
  pkceMethod: "S256",
  onLoad: "login-required"
};

let keycloakUpdatedConfig = {};

class SecuredKeyClock extends Component {
  constructor(props) {
    super(props);
    const loginFormData = cookieService.getCookie(
      this.props.cookies,
      "loginFormUserInfo"
    );
    this.state = {
      username: (loginFormData && loginFormData.username) || "",
      errors: {},
      submitBtnText: "Enter Password",
      redirectToReferrer: !!getLocalstorage("token"),
      data: {}
    };
  }

  async keyclockProviderEvent(event, error) {
    const { keycloakUserLogin, cookies } = this.props;

    if (event === "onAuthSuccess" && keycloak.authenticated) {
      let postLoginState = getLocalstorage("post_login_state");
      let redirectPath = PATHS.DASHBOARD;

      if (
        postLoginState &&
        postLoginState.from &&
        postLoginState.from.pathname
      ) {
        redirectPath =
          postLoginState.from.pathname + postLoginState.from.search;
        removeItemFromLocalStorage("post_login_state");
      }
      await setLocalstorage("token", keycloak.token || null);

      await keycloakUserLogin(
        {
          token: keycloak.token,
          userId: keycloak.tokenParsed.preferred_username
        },
        cookies
      );

      this.props.history.push(redirectPath);
    }
  }

  render() {
    const { username, errors, submitBtnText, redirectToReferrer } = this.state;
    const { location, loading } = this.props;
    const { from } = location.state || { from: { pathname: PATHS.DASHBOARD } };
    if (redirectToReferrer) return <Redirect to={from} />;

    keycloakUpdatedConfig = keycloakConfig;

    if (this.props.onLoad) {
      keycloakUpdatedConfig.onLoad = this.props.onLoad;
    }

    if (this.props.state) {
      setLocalstorage("post_login_state", this.props.state);
    }

    return (
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={keycloakUpdatedConfig}
        onEvent={(event, error) => this.keyclockProviderEvent(event, error)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    loginRequestData: state.loginReducer.loginRequestData,
    loading: state.loginReducer.loginRequestStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userSecurityKey,
      userLoginRequest,
      keycloakUserLogin
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SecuredKeyClock)
);
